export default function APIButton() {
    return (
        <button>Render API</button>
    )
}
